module.exports = require("ngx-bootstrap");